<h2
  *ngIf="
    (spinner || (stock && stock.length > 0)) &&
    campaignType !== campaignTypeEnum.RAFFLE &&
    requestType !== requestTypeEnum.vo
  "
  class="fw-light"
  [style]="'margin-top:40px; margin-bottom:20px'"
>
  {{ 'selectModelTitle' | i18next }}
</h2>
<h4
  *ngIf="
    (spinner || (stock && stock.length > 0)) &&
    campaignType === campaignTypeEnum.RAFFLE
  "
  class="fw-light"
  [style]="'margin-top:40px; margin-bottom:20px'"
>
  {{ 'selectPriorityRaffle' | i18next }}
</h4>
<h6
  *ngIf="!spinner && (!stock || stock.length === 0)"
  class="text-black fw-bold"
  [style]="'margin-top:40px; margin-bottom:20px'"
>
  {{
    requestType === requestTypeEnum.vo
      ? ('noStock' | i18next)
      : ('noStockVehicles' | i18next)
  }}
</h6>

<div class="main-container">
  <main
    class="main col-12 col-md-6 col-xl-4"
    *ngFor="let car of stock; let i = index"
    [class.selected]="isSelected(car)"
  >
    <ng-container *ngIf="requestType === requestTypeEnum.vo">
      <div class="main--imgContainer">
        <ng-container *ngIf="car.vehicleGroups[0]?.image?.split('|') as images">
          <div class="carousel-stage">
            <div class="carousel-inner">
              <div
                *ngFor="let imgUrl of images; let imgIdx = index"
                class="carousel-item"
                [class.active]="imgIdx === getImgIndex(i)"
              >
                <img
                  [src]="imgUrl"
                  class="main--imgContainer__img"
                  alt="Imagen vehículo VO"
                  (click)="openImageCarousel(images, imgIdx)"
                />
              </div>

              <div *ngIf="images.length === 0" class="carousel-item active">
                <img
                  src="../../../../assets/img/NeutroNaranjaRojo_v2.png"
                  class="main--imgContainer__img"
                  alt="Imagen vehículo VO"
                />
              </div>
            </div>

            <ng-container *ngIf="images.length > 1">
              <button
                class="carousel-control-prev"
                type="button"
                (click)="prevImg(i, images.length, $event)"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
              </button>

              <button
                class="carousel-control-next"
                type="button"
                (click)="nextImg(i, images.length, $event)"
              >
                <span
                  class="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
              </button>

              <div class="carousel-counter">
                {{ getImgIndex(i) + 1 }} / {{ images.length }}
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div class="main--infoContainer">
        <div class="main--vehicleInfo">
          <p
            class="main--vehicleInfo__model text-truncate"
            style="margin-bottom: 5px"
          >
            {{ car.modelName }}
          </p>
          <p class="main--vehicleInfo__color">
            {{ car.engine + ' ' + car.finish }}
          </p>
        </div>

        <div class="vo-details-box mt-2" style="font-size: 0.85rem">
          <div class="d-flex justify-content-between border-bottom py-1">
            <span
              class="fw-bold text-uppercase"
              style="font-size: 0.7rem; color: #666"
              >{{ 'plateNumber' | i18next }}</span
            >
            <span>{{ car.plateNumber }}</span>
          </div>
          <div class="d-flex justify-content-between border-bottom py-1">
            <span
              class="fw-bold text-uppercase"
              style="font-size: 0.7rem; color: #666"
              >{{ 'summaryVinNumberDate' | i18next }}</span
            >
            <span>{{ car.plateRegistrationDate | date: 'dd/MM/yyyy' }}</span>
          </div>
          <div class="d-flex justify-content-between border-bottom py-1">
            <span
              class="fw-bold text-uppercase"
              style="font-size: 0.7rem; color: #666"
              >{{ 'kms' | i18next }}</span
            >
            <span
              >{{
                car.vehicleGroups[0]?.kms | number: '1.0-0' : 'es-ES'
              }}
              km</span
            >
          </div>

          <div class="d-flex justify-content-between border-bottom py-1">
            <span
              class="fw-bold text-uppercase"
              style="font-size: 0.7rem; color: #dc3545"
              >{{ 'bookings' | i18next }}</span
            >
            <span style="color: #dc3545">{{
              car.vehicleGroups[0]?.bookingsVo | numberData
            }}</span>
          </div>

          <div
            class="price-container mt-3 py-2 px-2"
            style="background-color: #f8f9fa; border-radius: 4px"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-start">
                <p class="price-label">
                  {{ 'VOPrice' | i18next | uppercase }}
                </p>
                <p
                  class="main--pricesInfo__fee mb-0"
                  style="font-size: 1.4rem; line-height: 1"
                >
                  {{
                    car.vehicleGroups[0]?.prices?.priceVO
                      | number: '1.0-0' : 'es-ES'
                  }}
                </p>
              </div>

              <div class="text-end">
                <p class="price-label">
                  {{ 'VNPrice' | i18next | uppercase }}
                </p>

                <div
                  class="d-flex justify-content-end align-items-center gap-2"
                >
                  <span
                    class="text-muted text-decoration-line-through"
                    style="font-size: 1.1rem"
                  >
                    {{
                      car.vehicleGroups[0]?.prices?.priceVN
                        | number: '1.0-0' : 'es-ES'
                    }}€
                  </span>

                  <span class="text-danger fw-bold" style="font-size: 1rem">
                    -{{ car.vehicleGroups[0]?.prices?.discount }}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="main--btnContainer mt-3">
          <button
            *ngIf="!isBookedList"
            class="main--btnContainer__btn btn confirmBlack"
            (click)="requestCarButton(car)"
          >
            {{ 'reserve' | i18next | uppercase }}
          </button>
          <button
            *ngIf="isBookedList"
            class="main--btnContainer__btn btn confirmBlack"
            (click)="cancelBooking.emit(car.requestNumber)"
          >
            {{ 'btnDeleteBook' | i18next | uppercase }}
          </button>
          <button
            class="main--btnContainer__btn btn cancel"
            (click)="openCarDetail(car)"
          >
            {{ 'btnSeeDetail' | i18next | uppercase }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="requestType !== requestTypeEnum.vo">
      <p
        *ngIf="campaignType === campaignTypeEnum.RAFFLE"
        class="applicant-users"
      >
        {{ 'applicantUsers' | i18next }} {{ car.applicantUsers }}
      </p>
      <div class="main--imgContainer">
        <img
          class="main--imgContainer__img"
          [src]="car.image || '../../../../assets/img/NeutroNaranjaRojo_v2.png'"
          alt="Imagen vehículo"
        />
      </div>
      <div class="main--infoContainer">
        <div class="main--vehicleInfo">
          <div class="d-flex flex-row justify-content-between">
            <p class="main--vehicleInfo__fuel">{{ car.fuelType }}</p>
            <p
              *ngIf="requestType === 'CAMPAIGN'"
              class="main--vehicleInfo__fuel"
            >
              {{ 'color' | i18next }}
              {{ car.exteriorColor.description }}
            </p>
            <div
              *ngIf="requestType !== 'LEASING'"
              class="main--pricesInfo__row"
              (click)="openCarLegal(car)"
            >
              <div class="iconContainer">
                <img
                  class="iconContainer--icon"
                  src="../../../../assets/icons/info_black.svg"
                  alt="Información legal"
                  width="20px"
                />
              </div>
              <span>{{ 'legal' | i18next }}</span>
            </div>
          </div>
          <p class="main--vehicleInfo__model text-truncate">
            {{ car.model | valueData }}
          </p>
          <p class="main--vehicleInfo__color">
            {{ car.modelYear }} {{ car.exteriorColorDescription }}
          </p>
        </div>
        <div class="main--pricesInfo mt-1 align-items-start">
          <div>
            <p class="main--pricesInfo__title">
              {{ 'feeFrom' | i18next }}
              <span
                *ngIf="requestType !== 'LEASING'"
                style="cursor: pointer"
                (click)="openCarLegal(car)"
                >(*)</span
              >
            </p>
            <p class="main--pricesInfo__fee">
              {{ car.prices?.fee | numberData }}
            </p>
          </div>
          <div
            class="d-flex flex-column gap-2"
            *ngIf="requestType !== 'LEASING'"
          >
            <div
              class="d-flex flex-row justify-content-between gap-2 border-bottom"
            >
              <span class="small">{{ 'retributionPrimary' | i18next }}</span>
              <span>{{ car.prices?.primaryRE | numberData }}€</span>
            </div>
            <div
              class="d-flex flex-row justify-content-between gap-2 border-bottom"
            >
              <span class="small">{{ 'retributionSecondary' | i18next }}</span>
              <span>{{ car.prices?.secondaryRE | numberData }}€</span>
            </div>
            <div class="d-flex flex-row justify-content-between gap-2">
              <span class="small">{{
                'retributionEndowmentPrimary' | i18next
              }}</span>
              <span>{{ car.prices?.primaryEndowmentRE | numberData }}€</span>
            </div>
            <div class="d-flex flex-row justify-content-between gap-2" *ngIf="requestType !== 'CAMPAIGN'">
              <span class="small">{{
                'retributionEndowmentSecondary' | i18next
              }}</span>
              <span>{{ car.prices?.secondaryEndowmentRE | numberData }}€</span>
            </div>
          </div>
        </div>
        <div class="main--btnContainer" *ngIf="requestType !== 'CAMPAIGN'">
          <button
            class="main--btnContainer__btn btn confirmBlack"
            (click)="requestCarButton(car)"
          >
            {{ 'requestBtn' | i18next | uppercase }}
          </button>
          <button
            class="main--btnContainer__btn btn cancel"
            (click)="openCarDetail(car)"
          >
            {{ 'btnSeeDetail' | i18next | uppercase }}
          </button>
        </div>
        <div class="main--btnContainer" *ngIf="requestType === 'CAMPAIGN'">
          <button
            class="main--btnContainer__btn btn cancel"
            (click)="selectCar(car)"
            [disabled]="
              !isSelected(car) && selectedCars.length >= maxSelections
            "
          >
            {{
              isSelected(car)
                ? ('removeSelectionBtn' | i18next | uppercase)
                : ('selectVehicleBtn' | i18next | uppercase)
            }}
          </button>
          <button
            *ngIf="
              car &&
              !car.urlInfo &&
              ((car.optionals && car.optionals.length > 0) ||
                (car.extensions && car.extensions.length > 0))
            "
            class="main--btnContainer__btn btn"
            (click)="openCarEquipment(car)"
          >
            {{ 'btnSeeEquipment' | i18next | uppercase }}
          </button>
          <a
            *ngIf="car && car.urlInfo"
            class="main--btnContainer__btn btn"
            [href]="car.urlInfo"
            target="_blank"
          >
            {{ 'commercialSheet' | i18next | uppercase }}
          </a>
          <p
            *ngIf="
              getCarOrder(car) !== null &&
              campaignType === campaignTypeEnum.RAFFLE
            "
            class="order-badge"
          >
            {{ 'priority' | i18next }} {{ getCarOrder(car) }}
          </p>
        </div>
      </div>
    </ng-container>
  </main>
</div>

<div
  class="d-flex justify-content-between"
  style="margin-top: 40px"
  *ngIf="requestType !== requestTypeEnum.vo"
>
  <button
    class="btnContainer__btn btnContainer__btn__back"
    style="
      background-color: #2c2a29;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    "
    mat-button
    (click)="back()"
  >
    <mat-icon class="icon">arrow_back</mat-icon>
    {{ 'btnReturn' | i18next | uppercase }}
  </button>
  <button
    *ngIf="requestType === 'CAMPAIGN'"
    [disabled]="this.carList.length === 0"
    class="btnContainer--btn btn confirm"
    matStepperNext
    mat-button
    (click)="nextStep()"
    [style]="
      this.carList.length === 0
        ? 'background-color: #565554'
        : 'background-color: #2c2a29'
    "
  >
    {{ 'btnContinue' | i18next | uppercase }}
  </button>
</div>
